export default __webpack_public_path__ + "static/media/DCRPImg.6f0c0ea9.jpg";